import { useTranslation } from "react-i18next";

export default function COAFields({ data, artists, printUser }) {
  const { t, i18n } = useTranslation();

  const getFriendlyType = (rawType) => {
    switch (rawType) {
      case "RA4":
      case "RA4 Print type":
        return t("coa.type_ra4", "RA-4 (manual color print)");
      case "B/W":
      case "B/W Print type":
        return t("coa.type_bw", "Black & White (manual print)");
      case "Digital":
      case "Digital Print type":
        return t("coa.type_digital", "Digital print");
      default:
        return rawType;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    try {
      return new Intl.DateTimeFormat(i18n.language || "en", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(new Date(dateStr));
    } catch {
      return dateStr;
    }
  };

		
  const fields = [
    {
      label: t("coa.artists", "Artist"),
      value: artists.map((a) => `${a.firstName} ${a.lastName}`).join(", "),
    },
    {
      label: t("coa.type", "Print type"),
      value: getFriendlyType(data.type),
    },
    {
      label: t("coa.editionNumber", "Edition number"),
      value: data.editionNumber,
    },
    {
      label: t("coa.editionTotal", "Total edition size"),
      value: data.editionTotal,
    },
    {
      label: t("coa.size", "Print size"),
      value: data.size,
    },
    {
      label: t("coa.paperType", "Paper Type"),
      value: data.paperType,
    },
    {
      label: t("coa.printedBy", "Printed by"),
      value: printUser ? `${printUser.firstName} ${printUser.lastName}` : null,
    },
    {
      label: t("coa.printDate", "Print Date"),
      value: formatDate(data.printDate),
    },
  ];

  return (
    <div className="mt-4">
      <ol className="list-group list-group-separated col-12">
        {fields.map(
          (item, idx) =>
            item.value !== undefined &&
            item.value !== null &&
            item.value !== "" && (
              <li
                key={idx}
                className="list-group-item d-flex justify-content-between align-items-start text-black"
              >
                <span>
                  <p
                    className="lead mt-0"
                    style={{ lineHeight: "90%", textTransform: "uppercase" }}
                  >
                    {item.label}
                  </p>
                </span>
                <p
                  className="lead mt-0"
                  style={{
                    lineHeight: "90%",
                    textTransform: "uppercase",
                    textAlign: "right",
                  }}
                >
                  {item.value}
                </p>
              </li>
            )
        )}
      </ol>
    </div>
  );
}
